import Decoder from "./bmp_decoder.js";
import Encoder from "./bmp_encoder.js";
/**
 * Encodes data into BMP format.
 * @param data - Data for encoding.
 * @returns typed array buffer.
 */
export function encode(data) {
    const encoder = new Encoder(data);
    return encoder.encode();
}
/**
 * Decodes BMP format image into data.
 * @param data - Buffer with image data.
 * @returns - Decoded data.
 */
export function decode(data) {
    const decoder = new Decoder(data);
    return decoder.decode();
}
//# sourceMappingURL=index.js.map